"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var React = require('react');

var PropTypes = require('prop-types');

var _ = require('lodash');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var AddIcon = require('../icons/addItem.svg.js');

var _Symbol = require('../symbol');

var TextLabel = require('../textLabel');

var ADD_MODES = {
  SINGLE: 'single',
  MULTIPLE: 'multi',
  ALREADY_ADDED: 'added'
};

var AddableListItem = /*#__PURE__*/function (_React$Component) {
  _inherits(AddableListItem, _React$Component);

  var _super = _createSuper(AddableListItem);

  function AddableListItem() {
    var _this;

    _classCallCheck(this, AddableListItem);

    _this = _super.call(this);

    _this.handleClick = function () {
      var disabled = _this.props.disabled;
      var afterClick = _this.state.afterClick;

      if (disabled || afterClick || _this.alreadyAddedMode()) {
        return;
      }

      if (_this.singleMode()) {
        _this.setState({
          afterClick: true
        });
      }

      _this.props.onClick();
    };

    _this.getIconClassName = function () {
      var inProgress = _this.props.inProgress;
      var afterClick = _this.state.afterClick;

      if (inProgress) {
        return 'in-progress';
      }

      var alreadyAdded = afterClick && _this.singleMode() || _this.alreadyAddedMode();

      if (alreadyAdded) {
        return 'added';
      }

      return _this.state.afterClick ? 'added' : 'default';
    };

    _this.singleMode = function () {
      return _this.props.addMode === ADD_MODES.SINGLE;
    };

    _this.alreadyAddedMode = function () {
      return _this.props.addMode === ADD_MODES.ALREADY_ADDED;
    };

    _this.getItemStyle = function () {
      return _this.singleMode() ? {
        transitionDuration: _this.props.fadeOutDuration
      } : {};
    };

    _this.getTextWidth = function () {
      return "calc(100% - ".concat(!_.isEmpty(_this.props.contentBefore) * 96 + !_.isEmpty(_this.props.contentAfter) * 24, "px)");
    };

    _this.getItemClasses = function () {
      var _this$props = _this.props,
          getClassName = _this$props.getClassName,
          disabled = _this$props.disabled,
          inProgress = _this$props.inProgress,
          disableFadeOut = _this$props.disableFadeOut;
      var afterClick = _this.state.afterClick;
      var classNames = [];
      classNames.push(getClassName('control-addable-list-item'));

      if (disabled) {
        classNames.push('disabled');
      }

      var shouldFadeOut = !disableFadeOut && afterClick && _this.singleMode() && !inProgress;

      if (shouldFadeOut) {
        classNames.push('after-click');
      }

      return classNames.join(' ');
    };

    _this.state = {
      afterClick: false
    };
    return _this;
  }

  _createClass(AddableListItem, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.getItemClasses(),
        onClick: this.props.disabled ? null : this.handleClick,
        style: this.getItemStyle()
      }, this.props.contentBefore ? /*#__PURE__*/React.createElement("div", {
        key: "contentBefore",
        "data-aid": "content-before",
        className: "list-item-content-before"
      }, this.props.contentBefore) : null, /*#__PURE__*/React.createElement("div", {
        className: "list-item-content",
        style: {
          width: this.getTextWidth()
        }
      }, /*#__PURE__*/React.createElement(TextLabel, {
        className: "list-item-label",
        type: "T01",
        value: this.props.label,
        shouldTranslate: this.props.shouldTranslate,
        automationId: "text-label"
      }), this.props.description ? /*#__PURE__*/React.createElement(TextLabel, {
        automationId: "text-description",
        type: "T17",
        key: "description",
        value: this.props.description,
        shouldTranslate: this.props.shouldTranslate,
        className: 'list-item-description' + (this.props.disabled ? ' disabled' : '')
      }) : null), this.props.contentAfter ? /*#__PURE__*/React.createElement("div", {
        key: "contentAfter",
        "data-aid": "content-after",
        className: "list-item-content-after"
      }, this.props.contentAfter) : null, /*#__PURE__*/React.createElement(_Symbol, {
        "data-aid": "add-item-icon",
        className: 'add-item-icon ' + this.getIconClassName() + (this.props.disabled ? ' disabled' : '')
      }, /*#__PURE__*/React.createElement(AddIcon, null)));
    }
  }]);

  return AddableListItem;
}(React.Component);

AddableListItem.displayName = displayNames.ADDABLE_LIST_ITEM;
AddableListItem.propTypes = {
  /** A callback function to be triggered when the item is added */
  onClick: PropTypes.func.isRequired,

  /** The main title for the item */
  label: PropTypes.string.isRequired,

  /** When provided, a subtitle will be added to the item with this text*/
  description: PropTypes.string,

  /** Set a disabled behaviour on the component */
  disabled: PropTypes.bool,

  /** The duration of the item fadeout after the item was added */
  fadeOutDuration: PropTypes.string,

  /** Prevents clicking on an item right after it was clicked (for example while it is fading out) */
  inProgress: PropTypes.bool,

  /** Weather or not the item should be faded out after was added */
  disableFadeOut: PropTypes.bool,

  /** A slot to be renderer before the item label */
  contentBefore: PropTypes.element,

  /** A slot to be renderer after the item label */
  contentAfter: PropTypes.element,

  /** Set the mode of the item to be displayed properly. For `Single` the item is displayed as a new one. For `Added` the item is displayed as it was added already. `Multi` is not supported and behaves like `Single`. */
  addMode: PropTypes.oneOf([ADD_MODES.SINGLE, ADD_MODES.MULTIPLE, ADD_MODES.ALREADY_ADDED])
};
AddableListItem.defaultProps = {
  disabled: false,
  fadeOutDuration: '0.8s',
  inProgress: false,
  disableFadeOut: false,
  addMode: ADD_MODES.SINGLE
};
module.exports = compose(AddableListItem);